import RichTextsAndRichTextsWithIconsListBlock from './RichTextsAndRichTextsWithIconsListBlock';

export default RichTextsAndRichTextsWithIconsListBlock;
